// Server bilan aloqa: bitta klient butun panel uchun.
// URL va ochiq (publishable) kalit maxfiy emas — brauzerda turishi mo'ljallangan.
// Boshqa loyihaga ulash uchun Cloudflare'da VITE_SUPABASE_URL / VITE_SUPABASE_KEY beriladi.
import { OnePosClient } from '@onepos/client';

const URL = import.meta.env.VITE_SUPABASE_URL || 'https://nfijlgvzhaamnbtpnkcg.supabase.co';
const KEY = import.meta.env.VITE_SUPABASE_KEY || 'sb_publishable_E41UZoZJZWHQpIhUmIKHLg_zFrnF3CV';

export const api = new OnePosClient({ url: URL, key: KEY, storageKey: 'onepos.console.session' });

/** Restoran paneli manzili (yordam rejimida admin shu yerda o'z logini bilan kiradi) */
export const APP_URL = import.meta.env.VITE_APP_URL || 'https://app.onepos.uz';
